import React, { FunctionComponent, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type ModalProps = {
  opened: boolean;
  handleClose: () => void;
  title: string;
  text: string;
  children: React.ReactNode;
  actionName: string;
  handleAction: () => void;
  actionDisabled?: boolean;

  cancelActionName?: string;
  handleCancelAction?: () => void;
}

const Modal: FunctionComponent<ModalProps> = (props) => {
  const {
    opened,
    handleClose,
    actionName,
    children,
    handleAction,
    text,
    title,
    actionDisabled,
    handleCancelAction,
    cancelActionName
  } = props;

  return (
    <Dialog open={opened} onClose={handleClose}>
      <DialogTitle>{ title }</DialogTitle>
      <DialogContent>
        <DialogContentText>
          { text }
        </DialogContentText>

        { children }

      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelAction || handleClose}>{ cancelActionName || 'Cancel' }</Button>
        <Button disabled={actionDisabled} onClick={handleAction}>{ actionName }</Button>
      </DialogActions>
    </Dialog>
  );
}

export default Modal;
